import React, { Fragment, useState } from 'react';
import PropTypes from "prop-types";

// Cache the requested leads IDs locally, temporarily, just in case the user
// accesses the same lead popup twice
const requestedLeadIds = [];

function delay(time, timeElapsed = 0) {
  return new Promise((resolve) => {
    if (time <= timeElapsed) {
      resolve();
      return;
    }

    setTimeout(resolve, time - timeElapsed);
  });
}

function RequestLeadAccess(props) {
  const [requesting, setRequesting] = useState(false);
  const [requested, setRequested] = useState(() => requestedLeadIds.includes(props.leadId));
  const [failed, setFailed] = useState(false);

  const makeRequest = async (event) => {
    event.preventDefault();

    setRequesting(true);

    const requestedAt = Date.now();
    const request = {
      method: 'post',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        lead_id: props.leadId,
      }),
    };

    try {
      const response = await fetch('/api/request-lead-access', request);

      if (response.ok) {
        requestedLeadIds.push(props.leadId);
      }
    } catch (e) {
      //
    }

    await delay(2000, Date.now() - requestedAt);

    setFailed(!requestedLeadIds.includes(props.leadId));
    setRequested(true);
    setRequesting(false);
  };

  let actionElement = null;

  if (failed) {
    actionElement = (
      <span>Sorry, there was a problem requesting access. Please try again soon</span>
    );
  } else if (requested) {
    actionElement = <span>Thank you, the request has been made</span>;
  } else if (requesting) {
    actionElement = <span>One moment ...</span>;
  } else {
    actionElement = (
      <a
        className="tw-text-brand-green hover:tw-text-brand-green-light"
        href="mailto:megan@prospectpath.com"
        onClick={makeRequest}
      >
        Request Access
      </a>
    );
  }

  return (
    <Fragment>
      <div>This lead is exclusive to our partner vendors.</div>
      <div>To become a partner vendor please request access below.</div>
      <br />
      <div style={{ userSelect: 'none' }}>
        {actionElement}
      </div>
    </Fragment>
  );
}

RequestLeadAccess.propTypes = {
  leadId: PropTypes.number.isRequired,
};

export default RequestLeadAccess;
